import React, {useEffect, useState} from "react";
import AuthService from "../../services/auth.service";
import authService from "../../services/auth.service";
import "./style.css"
import {useNavigate} from "react-router-dom";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar";

export default function Cabinet() {
    const [currentUser, setCurrentUser] = useState(undefined);

    let navigate = useNavigate();
    useEffect(() => {
        let cancelled = false;
        const load = async () => {
            try {
                const user = localStorage.getItem('token') ? await AuthService.checkAuth() : null;
                if (user && !cancelled) setCurrentUser(user);
            } catch { /* The anonymous cabinet keeps the login and catalog links. */ }
        };
        load();
        return () => { cancelled = true; };
    }, []);

    const deleteAccount = async () => {
        const displayConfirm = async () => {
            return window.confirm('Вы уверены в том, что хотите удалить аккаунт?');
        };
        if (await displayConfirm()) {
            authService.deleteAccount()
                .then(
                    () => {
                        window.alert('Аккаунт удалён.');
                        navigate('/')
                        window.location.reload()
                    },
                    (error) => {
                        window.alert("Не удалось удалить аккаунт. Попробуйте ещё раз.");
                        console.log(error.response.data.message)

                    })
        }
    }

    return (
        <div className="bg-white h-100">
            <Navbar currentUser={currentUser} setCurrentUser={setCurrentUser}/>
            <div className="container about-container mt-3">
                <div className="text-center">
                    <h6 className="about-text mx-auto mt-2">Личный кабинет находится в разработке. При желании вы можете удалить
                        аккаунт и все ваши данные с сайта, воспользовавшись кнопкой "Удалить аккаунт".</h6>
                </div>
            </div>
            {
                currentUser ?
                    <React.Fragment>
                        <div className="container mt-5">
                            <div className="row d-flex justify-content-center delete-account">
                                <button className="w-auto btn btn-danger text-white delete-account-btn"
                                        onClick={deleteAccount}>
                                    Удалить аккаунт
                                </button>
                            </div>
                        </div>
                        <Footer/>
                    </React.Fragment>
                    :
                    <React.Fragment>
                        <div className="d-flex registration-alert justify-content-center row me-0 text-center"
                             style={{"height": "75%"}}>
                            <h3 className="align-self-center ms-sm-5 col-md-8">Чтобы открыть личный кабинет, <a
                                    href="/signup">зарегистрируйтесь</a> или <a
                                    href="/login">войдите в аккаунт</a>. <a href="/">Открыть каталог</a>.</h3>
                        </div>
                        <Footer/>
                    </React.Fragment>
            }
        </div>
    )
}
